import Vue from 'vue';
import VueRouter from 'vue-router';
import firebase from 'firebase';

import Dashboard from '../layouts/Dashboard.vue';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    redirect: '/login',
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "register" */ '../views/Register.vue'),
  },
  {
    path: '/dashboard',
    name: 'home',
    component: Dashboard,
    children: [
      {
        path: '',
        name: 'home',
        component: Home,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: '/add',
        name: 'add',
        component: () => import(/* webpackChunkName: "addArtiste" */ '../views/AddArtiste.vue'),
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const { currentUser } = firebase.auth();
  const requireAuth = to.matched.some(record => record.meta.requireAuth);

  if (requireAuth && !currentUser) {
    next('login');
  } else if (!requireAuth && currentUser) {
    next('home');
  } else {
    next();
  }
});

export default router;
